import React from 'react';
import { Box, Group, Progress, Text } from '@mantine/core';

export interface GanttExportProgressProps {
  visible: boolean;
  percent: number;
}

/**
 * Full-width export progress strip in the Gantt toolbar.
 */
export function GanttExportProgress({ visible, percent }: GanttExportProgressProps) {
  if (!visible) {
    return null;
  }

  const preparing = percent === 0;
  const complete = percent >= 100;

  return (
    <Box
      style={{ width: '100%', flexBasis: '100%' }}
      px={4}
      pb={4}
      pt={2}
      aria-live="polite"
      aria-busy={!complete}
    >
      <Group gap="sm" wrap="nowrap" align="center">
        <Text size="xs" c="dimmed" fw={500} style={{ minWidth: 168 }}>
          {complete
            ? 'Export complete'
            : preparing
              ? 'Preparing project file…'
              : 'Downloading project file…'}
        </Text>
        <Progress
          style={{ flex: 1 }}
          size="md"
          radius="xl"
          color={complete ? 'teal' : 'brand'}
          value={preparing ? 100 : percent}
          animated={preparing}
          striped={preparing && !complete}
        />
        <Text size="xs" fw={600} c={complete ? 'teal' : undefined} style={{ minWidth: 40, textAlign: 'right' }}>
          {preparing ? '…' : `${percent}%`}
        </Text>
      </Group>
    </Box>
  );
}
